// import React from "react";
// import CustomButton from "./CustomButton";
// import { motion } from "framer-motion";

// type HeroProps = {
//   title?: string;
//   description?: string;
//   src?: string;
//   alt?: string;
//   button?: React.ReactElement<typeof CustomButton> | null;
// };

// const Hero: React.FC<HeroProps> = ({
//   title,
//   description,
//   src,
//   alt,
//   button,
// }) => {
//   const backgroundImageStyle = src ? { backgroundImage: `url(${src})` } : {};

//   return (
//     <div className="w-full h-screen overflow-hidden">
//       {/* Background Image */}
//       <div
//         className="absolute inset-0 bg-cover bg-center bg-no-repeat"
//         style={backgroundImageStyle}
//       ></div>

//       {/* Content */}
//       <div className="relative z-10 w-[90%] md:w-4/5 max-w-4xl mx-auto h-4/5 flex flex-col p-6 md:px-24 items-center justify-center gap-6 bg-white/90">
//         <motion.h2
//           initial={{ x: -150, opacity: 0, rotate: -5 }}
//           animate={{ x: 0, opacity: 1, rotate: 0 }}
//           transition={{
//             type: "spring",
//             stiffness: 100,
//             damping: 15,
//             delay: 0.2,
//           }}
//           className="font-CrimsonText font-bold text-xl md:text-4xl text-primaryColor text-center md:px-16"
//         >
//           {title}
//         </motion.h2>

//         <motion.p
//           initial={{ x: 150, opacity: 0 }}
//           animate={{ x: 0, opacity: 1 }}
//           transition={{ type: "tween", duration: 1.2, delay: 0.5 }}
//           className="text-center font-CrimsonText text-base md:text-xl text-textColor"
//         >
//           {description}
//         </motion.p>

//         {button && (
//           <motion.div
//             initial={{ y: 50, opacity: 0 }}
//             animate={{ y: 0, opacity: 1 }}
//             transition={{
//               type: "spring",
//               stiffness: 120,
//               damping: 20,
//               delay: 0.8,
//             }}
//             className="mt-4"
//           >
//             {button}
//           </motion.div>
//         )}

//         <div className="hidden md:flex md:w-24 md:h-24 absolute bottom-4 right-4">
//           <img
//             src={require("../assets/icon.png")}
//             alt={alt || ""}
//             className="w-full h-full object-cover"
//           />
//         </div>
//       </div>
//     </div>
//   );
// };

// export default Hero;

import React from "react";
import CustomButton from "./CustomButton";
import { motion } from "framer-motion";

type HeroProps = {
  title?: string;
  description?: string;
  src?: string;
  alt?: string;
  button?: React.ReactElement<typeof CustomButton> | null;
  navbarHeight?: number; // Pass dynamic height from Navbar
};

const Hero: React.FC<HeroProps> = ({
  title,
  description,
  src,
  alt,
  button,
  navbarHeight = 0,
}) => {
  const backgroundImageStyle = src ? { backgroundImage: `url(${src})` } : {};

  return (
    <div
      className="w-full relative overflow-hidden flex justify-center items-center"
      style={{
        height: `calc(100vh - ${navbarHeight}px)`,
      }}
    >
      {/* Background Image */}
      <div
        className="absolute inset-0 bg-cover bg-center bg-no-repeat"
        style={backgroundImageStyle}
      ></div>

      {/* Centered Content */}
      <div className="  md:rounded-3xl relative z-10 w-[90%] md:w-4/5 max-w-4xl h-3/5 md:h-1/2 flex flex-col items-center justify-center gap-0 md:gap-6 bg-white/90 p-4 md:px-10">
        <motion.h2
          initial={{ x: -150, opacity: 0, rotate: -5 }}
          animate={{ x: 0, opacity: 1, rotate: 0 }}
          transition={{
            type: "spring",
            stiffness: 100,
            damping: 15,
            delay: 0.2,
          }}
          className="font-CrimsonText font-bold text-base md:text-2xl text-primaryColor text-center md:px-16"
        >
          {title}
        </motion.h2>

        <motion.p
          initial={{ x: 150, opacity: 0 }}
          animate={{ x: 0, opacity: 1 }}
          transition={{ type: "tween", duration: 1.2, delay: 0.5 }}
          className="text-center font-CrimsonText text-sm md:text-base text-textColor"
        >
          {description}
        </motion.p>

        {/* {button && (
          <motion.div
            initial={{ y: 50, opacity: 0 }}
            animate={{ y: 0, opacity: 1 }}
            transition={{
              type: "spring",
              stiffness: 120,
              damping: 20,
              delay: 0.8,
            }}
            className="mt-4"
          >
            {button}
          </motion.div>
        )} */}

        {/* Optional bottom-right icon */}
        <div className="hidden md:flex md:w-24 md:h-24 absolute bottom-0 right-0">
          <img
            src={require("../assets/icon.png")}
            alt={alt || ""}
            className="w-full h-full object-cover"
          />
        </div>
      </div>
    </div>
  );
};

export default Hero;
